import { InfoCenterFile } from "./InfoCenterFile";

export class Category {
  constructor() {
    this.CategoryID = -1;
    this.Name = "";
    this.Children = [];
    this.Files = [];
    this.Selected = false;
    this.NestLevel = 0;
  }

  public Name: string;
  public CategoryID: number;
  public CategoryType: string;
  public CreatedBy: string;
  public CreateDate: Date;
  public UpdatedBy: string;
  public UpdateDate: Date;
  public SortOrder: number;
  public ParentID: number;
  public Children: Category[];
  public Files: InfoCenterFile[];
  public Selected: boolean;

  public NestLevel: number;
}
